// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"e2e6df9f","617":"4d07fad4","743":"b7cdac4d"}[chunkId] + ".chunk.js";
};